import { type StatsItem } from "../models";

export const formatTooltipTitle = ({ date }: StatsItem): string => date ?? "-";
